import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface PortalSelectedSlotPayload {
  calendars_id: number;
  users_id?: number | null;
  start?: string;
  end?: string;
  start_utc?: string;
  end_utc?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PatientPortalService {
  constructor(private readonly http: HttpClient) {}

  private baseUrl(customerIdentifier: string, siteIdentifier: string): string {
    return `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/public/book/${customerIdentifier}/${siteIdentifier}`;
  }

  bootstrap(customerIdentifier: string, siteIdentifier: string) {
    return this.http.get(this.baseUrl(customerIdentifier, siteIdentifier));
  }

  treatments(customerIdentifier: string, siteIdentifier: string) {
    return this.http.get(
      `${this.baseUrl(customerIdentifier, siteIdentifier)}/treatments`
    );
  }

  availability(
    customerIdentifier: string,
    siteIdentifier: string,
    payload: {
      treatment_id: number;
      day: string;
      selected_slots?: PortalSelectedSlotPayload[];
    }
  ) {
    return this.http.post(
      `${this.baseUrl(customerIdentifier, siteIdentifier)}/availability`,
      payload
    );
  }

  availabilityMonth(
    customerIdentifier: string,
    siteIdentifier: string,
    payload: {
      treatment_id: number;
      month: string;
      selected_slots?: PortalSelectedSlotPayload[];
    }
  ) {
    return this.http.post(
      `${this.baseUrl(customerIdentifier, siteIdentifier)}/availability/month`,
      payload
    );
  }

  availabilityDays(
    customerIdentifier: string,
    siteIdentifier: string,
    payload: {
      treatment_id: number;
      selected_slots?: PortalSelectedSlotPayload[];
    }
  ) {
    return this.http.post(
      `${this.baseUrl(customerIdentifier, siteIdentifier)}/availability/days`,
      payload
    );
  }

  availabilityProfessionals(
    customerIdentifier: string,
    siteIdentifier: string,
    payload: {
      treatment_id: number;
      day: string;
      start_utc: string;
      end_utc: string;
      selected_slots?: PortalSelectedSlotPayload[];
    }
  ) {
    return this.http.post(
      `${this.baseUrl(customerIdentifier, siteIdentifier)}/availability/professionals`,
      payload
    );
  }

  createRequests(
    customerIdentifier: string,
    siteIdentifier: string,
    payload: any
  ) {
    return this.http.post(
      `${this.baseUrl(customerIdentifier, siteIdentifier)}/requests`,
      payload
    );
  }

  getManagedBooking(
    customerIdentifier: string,
    siteIdentifier: string,
    token: string
  ) {
    return this.http.get(
      `${this.baseUrl(customerIdentifier, siteIdentifier)}/manage/${encodeURIComponent(token)}`
    );
  }

  cancelManagedBookingAppointment(
    customerIdentifier: string,
    siteIdentifier: string,
    token: string,
    appointments_id: number
  ) {
    return this.http.post(
      `${this.baseUrl(customerIdentifier, siteIdentifier)}/manage/${encodeURIComponent(token)}/cancel`,
      { appointments_id }
    );
  }

  getManagedBookingRescheduleAvailability(
    customerIdentifier: string,
    siteIdentifier: string,
    token: string,
    payload: {
      appointments_id: number;
      month?: string;
      day?: string;
      start_utc?: string;
      end_utc?: string;
    }
  ) {
    return this.http.post(
      `${this.baseUrl(customerIdentifier, siteIdentifier)}/manage/${encodeURIComponent(token)}/reschedule/availability`,
      payload
    );
  }

  rescheduleManagedBookingAppointment(
    customerIdentifier: string,
    siteIdentifier: string,
    token: string,
    payload: {
      appointments_id: number;
      calendars_id: number;
      users_id?: number | null;
      start_utc: string;
      end_utc: string;
    }
  ) {
    return this.http.post(
      `${this.baseUrl(customerIdentifier, siteIdentifier)}/manage/${encodeURIComponent(token)}/reschedule`,
      payload
    );
  }
}
